import { defineReceiver, defineCommand } from '@drapejs/invoker';
import { gql } from 'graphql-request';
import { request, query } from '@distancify/drapejs-litium';

export const commands = {
  countrySwitcher: defineCommand<{
    url: string;
    countryId: string;
  }>('getChannels'),
};

export const receivers = {
  countrySwitcher: defineReceiver(
    commands.countrySwitcher,
    async function (command, data) {
      const result = await request(
        this.cache,
        query(gql`
          query countrySwitcher {
            countrySwitcher {
              availableCountries {
                channelSystemId
                name
                rootPath
                current
                countryId
                culture
                currencySymbol
              }
            }
          }
        `)
      );
      await this.cache.setItem('__countrySwitcher', result.countrySwitcher);
      return result.countrySwitcher;
    },
    'litium'
  ),
};
